import { render, staticRenderFns } from "./JoinPlusModal.vue?vue&type=template&id=5cffdd98&scoped=true&"
import script from "./JoinPlusModal.vue?vue&type=script&lang=ts&"
export * from "./JoinPlusModal.vue?vue&type=script&lang=ts&"
import style0 from "./JoinPlusModal.vue?vue&type=style&index=0&id=5cffdd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cffdd98",
  null
  
)

export default component.exports